"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDifference = exports.calculatePosition = void 0;
const calculatePosition = (a, b, n) => (1 - n) * a + n * b;
exports.calculatePosition = calculatePosition;
const calculateDifference = (current, target) => {
    return Math.sqrt(Math.pow(target.x - current.x, 2) + Math.pow(target.y - current.y, 2));
};
exports.calculateDifference = calculateDifference;
//# sourceMappingURL=utils.js.map